import MessageAttachmentContainer from './container';
import MessageAttachment from './MessageAttachment';

export { MessageAttachment };
export default MessageAttachmentContainer;
